import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import type { CsvTableBinding } from "./csv-store-sync";

/**
 * Per-document registry of CSV table bindings.
 * Maps tableName → CsvTableBinding for every CSV imported into the Store.
 */
export const $csvBindings = atomFamily((documentId: string) => {
	const bindingsAtom = atom({} as Record<string, CsvTableBinding>);
	bindingsAtom.debugLabel = `csvBindings/${documentId}`;
	return bindingsAtom;
});

/**
 * Register a CSV binding for a document.
 */
export const $registerCsvBinding = atom(
	null,
	(get, set, { documentId, binding }: { documentId: string; binding: CsvTableBinding }) => {
		const current = get($csvBindings(documentId));
		set($csvBindings(documentId), { ...current, [binding.tableName]: binding });
	}
);
$registerCsvBinding.debugLabel = "registerCsvBinding";

/**
 * Unregister a CSV binding by table name.
 */
export const $unregisterCsvBinding = atom(
	null,
	(get, set, { documentId, tableName }: { documentId: string; tableName: string }) => {
		const current = get($csvBindings(documentId));
		const { [tableName]: _, ...rest } = current;
		set($csvBindings(documentId), rest);
	}
);
$unregisterCsvBinding.debugLabel = "unregisterCsvBinding";
